import React, { Component, Fragment } from 'react';
import classnames from 'classnames';
import { track } from 'react-tracking';
import { Message, IModerationHotKeysState as HotKeysSettings } from '../../state/types';

import Icon from '../../../../../../libraries/utils/components/icon';
import styles from './ModerationActiveBar.module.scss';

interface Props {
  itemsList: Message[];
  numberOfCheckedItems: number;
  hotKeysSettings: HotKeysSettings;
  onCloseActiveBar: () => void;
  onToggleActiveBar: () => void;
}
class ModerationActiveBar extends Component<Props> {
  static defaultProps = {
    itemsList: []
  };

  openContainer = () => {
    const { onToggleActiveBar, itemsList, hotKeysSettings } = this.props;
    onToggleActiveBar();
    itemsList[hotKeysSettings?.cursor]?.setChecked(true);
    this.props.tracking?.trackEvent({ eventName: 'keyboard shortcuts clicked' });
  };

  componentWillUnmount = () => {
    const { isModerationBarActive } = this.props.hotKeysSettings;
    if (isModerationBarActive) {
      this.props.onCloseActiveBar();
    }
  };

  render() {
    const { onToggleActiveBar, hotKeysSettings, numberOfCheckedItems } = this.props;
    const { isModerationBarActive } = hotKeysSettings;

    return (
      <Fragment>
        <div
          className={classnames(styles.container, { [styles.isExpanded]: isModerationBarActive })}
        >
          <span className={styles.arrow} onClick={onToggleActiveBar} />

          <div className={styles.activeBar}>
            <div className={styles.itemsCounter}>{numberOfCheckedItems}</div>
            <div className={styles.buttonsContainer}>
              <div className={styles.button}>
                Exit
                <span className={styles.key}>Esc</span>
              </div>
              <div className={styles.button}>
                Grab
                <div className={styles.grabButtons}>
                  <span className={classnames(styles.key, styles.isSymbol)}>&#8679;</span>
                  <span className={classnames(styles.key, styles.isSymbol)}>&darr;</span>
                </div>
              </div>
              <div className={styles.button}>
                Next
                <span className={classnames(styles.key, styles.isSymbol)}>&#8677;</span>
              </div>
              <div className={styles.button}>
                Show Conversation
                <span className={styles.key}>Space</span>
              </div>
              <div className={styles.button}>
                <div className={styles.label}>
                  <Icon name="block" className="block-red-icon" />
                  <span className={styles.label}>Reject</span>
                </div>
                <span className={classnames(styles.key, styles.isSymbol, styles.isMaxWidth)}>
                  &larr;
                </span>
              </div>
              <div className={styles.button}>
                <div className={styles.label}>
                  <Icon name="approve" className="approve-green-icon" />
                  <span className={styles.label}>Approve</span>
                </div>
                <span className={classnames(styles.key, styles.isSymbol, styles.isMaxWidth)}>
                  &rarr;
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          className={classnames(styles.closedContainer, {
            [styles.isExpanded]: isModerationBarActive
          })}
          onClick={this.openContainer}
        >
          Keyboard Shortcuts
        </div>
      </Fragment>
    );
  }
}

export default track()(ModerationActiveBar);
